<template>
  <div id="app" class="back-img">
    <div v-if="affixLeftTop" style="position: fixed;z-index: 9999; left: 10px;top:30%;width: 150px;height: 300px;">
      <img style="height: 100%;width: 100%" src="#"/>
      <p><span>广告位招租</span></p>
      <a @click="affixLeftTop = false"><Icon type="md-close-circle" /></a>
    </div>
    <div v-if="affixRightTop" style="position: fixed;z-index: 9999; right: 10px;top:30%;width: 150px;height: 300px;">
      <img style="height: 100%;width: 100%" src="#"/>
      <p><span>广告位招租</span></p>
      <a @click="affixRightTop = false"><Icon type="md-close-circle" /></a>
    </div>
    <div style="background-color:#d9d6c3;text-align: left;height: 20px">
      <span class="apex" style="margin-left: 50px;">欢迎来到文科软（宁德)交易中心!</span>
      <a class="apex" @click="login = true" style="margin-left: 50px;">登录</a>
      <span class="apex" style="margin-left: 10px;">|</span>
      <a class="apex" @click="reg = true" style="margin-left: 10px;">注册</a>
      <a class="apex" @click="login = true" style="margin-left: 40%;">买家中心</a>
      <a class="apex" @click="login = true" style="margin-left: 20px;">卖家中心</a>
      <span class="apex" @click="login = true" style="margin-left: 20px;">|</span>
      <a class="apex" @click="login = true" style="margin-left: 20px;">进货单（0）</a>
      <a class="apex" @click="login = true" style="margin-left: 20px;">我的消息（0）</a>
    </div>
    <div style="margin-top: 50px;margin-left: 300px;">
      <Row style="text-align: center;font-size: 20px">
        <Col span="3">
          <a  @click="IndexChange">首页</a>
        </Col>
        <Col span="3">
        <a @click="CommodityChange">供应信息</a>
        </Col>
        <Col span="3">
        <a @click="PublishChange">需求列表</a>
        </Col>
        <Col span="3">
        <a >行业资讯</a>
        </Col>
        <Col span="3">
        <a @click="join = true">加入我们</a>
        </Col>

      </Row>
    </div>
    <router-view/>
    <Modal v-model="login" title="登录" width="500px" :styles="{top: '60px'}">
      <Row style="margin-top: 20px;text-align: center">
        <Col >
        <Input type="text" placeholder="请输入登录名："/>
        </Col>
      </Row>
      <Row style="margin-top: 20px;text-align: center">
        <Col>
        <Input type="password" placeholder="请输入密码："/>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col>
        <Button type="primary" @click="sumbit()">登录</Button>
        <Button type="primary" @click="regs()">注册</Button>
        </Col>
      </Row>
      <div slot="footer"></div>
    </Modal>
    <Modal v-model="reg" title="注册" width="500px" :styles="{top: '60px'}">
      <Row style="margin-top: 20px;text-align: center">
        <Col style="text-align: left">
        <Input type="text" placeholder="请输入登录名：" v-model="user"/>
        </Col>
      </Row>
      <Row style="margin-top: 20px;text-align: center">
        <Col>
        <Input type="password" placeholder="请输入密码：" v-model="pass1"/>
        </Col>
      </Row>
      <Row style="margin-top: 20px;text-align: center">
        <Col>
        <Input type="password" placeholder="请确认密码：" v-model="pass2" />
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col>
        <Button type="primary" @click="sumbit1()">注册</Button>
        <Button type="primary" @click="reset()">重置</Button>
        </Col>
      </Row>
      <div slot="footer"></div>
    </Modal>
    <Modal v-model="join" title="加入我们" width="500px" :styles="{top: '60px'}">
      <Row style="margin-top: 20px;text-align: center">
        <Col >
        <Input type="text" placeholder="请输入姓名："/>
        </Col>
      </Row>
      <Row style="margin-top: 20px;text-align: center">
        <Col>
        <Input type="text" placeholder="请输入联系方式："/>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col>
        <Button type="primary" @click="InJoin()">提交</Button>
        </Col>
      </Row>
      <div slot="footer"></div>
    </Modal>
    <footer>
      <div style="text-align: center">
        <Row style="font-size: 20px;text-align: center">
          <Col span="6">
          支付方式
          </Col>
          <Col span="6">
          服务保障
          </Col>
          <Col span="6">
          商家服务
          </Col>
          <Col span="6">
          物流配送
          </Col>
        </Row>
        <Row style="font-size: 13px;margin-top: 10px;text-align: center">
          <Col span="6">
          公司转账
          </Col>
          <Col span="6">
          正品保证
          </Col>
          <Col span="6">
          商家服务
          </Col>
          <Col span="6">
          免运费
          </Col>
        </Row>
        <Row style="font-size: 13px;margin-top: 10px;text-align: center">
          <Col span="6">
          货到付款
          </Col>
          <Col span="6">
          7天无理由退换
          </Col>
          <Col span="6">
          培训中心
          </Col>
          <Col span="6">
          海外配送
          </Col>
        </Row>
        <Row style="font-size: 13px;margin-top: 10px;text-align: center">
          <Col span="6">
          在线支付
          </Col>
          <Col span="6">
          退货返运费
          </Col>
          <Col span="6">
          广告服务
          </Col>
          <Col span="6">
          EMS
          </Col>
        </Row>
        <Row style="font-size: 13px;margin-top: 10px;text-align: center">
          <Col span="6">
          分期付款
          </Col>
          <Col span="6">
          7X15小时客户服务
          </Col>
          <Col span="6">
          服务市场
          </Col>
          <Col span="6">
          211限时达
          </Col>
        </Row>
      </div>
      <p>文科软（宁德)科技有限公司</p>
      <p><a href="https://beian.miit.gov.cn">闽ICP备2022004002号</a></p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      affixLeftTop:true,
      affixRightTop:true,
      login:false,
      reg:false,
      join:false,
      user:"",
      pass1:"",
      pass2:"",
    }
  },
  methods: {
    sumbit(){
      this.$Message.error("登录失败，请联系客服")
      this.login=false;
    },
    InJoin(){
      this.$Message.success("提交成功，请等待人事与您联系")
      this.join=false;
    },
    sumbit1(){
      if(this.user==""){
        this.$Message.error("注册失败，请填写用户名")
      }else{
        if(this.pass1==this.pass2){
          this.$Message.success("注册成功，请登录")
          this.reg=false;
          this.login=true;
        }else{
          this.$Message.error("注册失败，密码不一致")
        }
      }
    },
    CommodityChange(){
      this.$router.push({path:'/commodity'})
    },
    PublishChange(){
      this.$router.push({path:'/publish'})
    },
    IndexChange(){
      this.$router.push({path:'/'})
    },
    regs(){
      this.login=false;
      this.reg=true;
    },
    reset(){
      this.user="";
      this.pass1="";
      this.pass2="";
    }
  },
}
</script>

<style>
  footer {
    background-color: #dddddd;
    border-top: 2px solid #ddd;
    padding: 10px;
  }

  footer p {
    text-align: center;
    line-height: 24px;
    font-size: 12px;
  }
  .apex{
    font-size: 15px;
  }
#app {
  background-color: #fffffb;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
  .back-img{
    /*background-image: url("assets/back.jpg");*/
    /*background-repeat: revert;*/
  }
</style>



// WEBPACK FOOTER //
// src/App.vue